<script setup lang="ts">
  const chatStore = useChatStore();
  const { chatColor1, chatColor2, isChameleonMode } = storeToRefs(chatStore);
</script>

<template>
  <div class="chat-bg-animation-wrapper">
    <ChatShapesChatBgShape1
      :color1="chatColor1"
      :color2="chatColor2"
      :is-chameleon-mode="isChameleonMode" />
    <ChatShapesChatBgShape2
      :color1="chatColor1"
      :color2="chatColor1"
      :is-chameleon-mode="isChameleonMode" />
    <ChatShapesChatBgShape3
      :color1="chatColor1"
      :color2="chatColor1"
      :is-chameleon-mode="isChameleonMode" />
    <ChatShapesChatBgShape4
      :color1="chatColor1"
      :color2="chatColor2"
      :is-chameleon-mode="isChameleonMode" />
    <ChatShapesChatBgShape5
      :color1="chatColor2"
      :color2="chatColor1"
      :is-chameleon-mode="isChameleonMode" />
    <ChatShapesChatBgShape6
      :color1="chatColor1"
      :color2="chatColor2"
      :is-chameleon-mode="isChameleonMode" />
  </div>
</template>
